import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { BackendURL } from "../../../env";

const AuthStart: React.FC = () => {
  const navigate = useNavigate();
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    let isMounted = true;

    const startAuthentication = async () => {
      try {
        // Old behavior kept for reference:
        // if an active session existed, we skipped Microsoft auth and went straight to "/".
        // const sessionResponse = await fetch(`${BackendURL}/session-user`, {
        //   credentials: "include",
        // });
        //
        // if (sessionResponse.ok) {
        //   navigate("/", { replace: true });
        //   return;
        // }

        // Active behavior:
        // always start with a fresh server session so URL hit always goes through Microsoft auth.
        await fetch(`${BackendURL}/api/logout`, {
          method: "POST",
          credentials: "include",
        });

        const authResponse = await fetch(`${BackendURL}/api/auth/start`, {
          credentials: "include",
        });

        const data = await authResponse.json();

        if (!authResponse.ok || !data.auth_url) {
          throw new Error(data.error || "Unable to start Microsoft authentication.");
        }

        window.location.replace(data.auth_url);
      } catch (error) {
        console.error("Authentication start failed:", error);
        if (isMounted) {
          setHasError(true);
        }
      }
    };

    startAuthentication();

    return () => {
      isMounted = false;
    };
  }, [navigate]);

  if (hasError) {
    return <div />;
  }

  return null;
};

export default AuthStart;
